module.exports = __webpack_public_path__ + "img/square-exclamation.ee5fa84f.svg";